import { useTranslation } from 'react-i18next';

import { Dropdown, snack } from '@innovamat/glimmer-components';

import type { Organization } from '@innovamat/glow-api-client';
import {
  useAllOrganizationsQuery,
  useChangeOrganizationMutation,
} from '@innovamat/glow-api-client';

import { useUser } from '../../../../user-management';
import { updateCurrentUserData } from '../../../utils/update-current-user-data';

type Props = {
  onChangeOrganization: () => void;
};

function SelectOrganization({ onChangeOrganization }: Props): JSX.Element {
  const { t } = useTranslation();
  const { user } = useUser();
  const { data } = useAllOrganizationsQuery<{
    allOrganizations: Organization[];
  }>();

  const organizations = data?.allOrganizations || [];
  const currentOrganization = user?.organization;

  const changeOrganizationMutation = useChangeOrganizationMutation();

  const handleSelect = (organization: Organization): void => {
    onChangeOrganization();
    changeOrganizationMutation.mutate(
      { body: { schoolId: organization.id!, userId: user?.id! } },
      {
        onSuccess: async () => {
          await updateCurrentUserData(organization);
          window.location.reload();
        },
        onError: () => {
          snack.error(t('errors.organizations.changeOrganization'));
        },
      }
    );
  };

  return (
    <Dropdown closeOnSelectItem>
      <Dropdown.Toggle label={currentOrganization?.name} />
      <Dropdown.Content>
        {organizations
          .filter((organization) => organization.id !== currentOrganization?.id)
          .map((organization) => (
            <Dropdown.Item
              state={'active'}
              onSelectItem={() => handleSelect(organization)}
            >
              {organization.name}
            </Dropdown.Item>
          ))}
      </Dropdown.Content>
    </Dropdown>
  );
}

export { SelectOrganization };
